import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { acceptedAdminRoles } from './routesObj'

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.isLoggedIn && acceptedAdminRoles.includes(rest.role) ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/' }} />
      )
    }
  />
);

export default AdminRoute;
